import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';
import each from 'lodash/each';
import map from 'lodash/map';

export default class VisSection extends Component {
	constructor() {
		super({
			element: '.vis',
			elements: {
				container: '.vis__container',
				rows: '.vis__row',
			},
		});
	}

	create() {
		super.createComponent();
		this.createTimeline();
		this.animateTimeline();
	}

	createTimeline() {
		this.timelineInstant = GSAP.timeline({
			scrollTrigger: {
				trigger: this.element,
				start: 'top bottom',
				end: 'bottom top',
				toggleActions: 'restart none none reverse',
				markers: true,
				scrub: true,
			},
		});
	}

	animateTimeline() {
		this.timelineInstant.fromTo(
			this.elements.rows[0],
			{
				xPercent: 20,
			},
			{
				xPercent: -30,
				ease: 'out.expo',
				duration: 1.25,
			},
			0
		);
		this.timelineInstant.fromTo(
			this.elements.rows[1],
			{
				xPercent: -30,
			},
			{
				xPercent: 20,
				ease: 'out.expo',
				duration: 1.25,
			},
			0
		);
		this.timelineInstant.fromTo(
			this.elements.rows[2],
			{
				xPercent: 40,
			},
			{
				xPercent: -10,
				ease: 'out.expo',
				duration: 1.25,
			},
			0
		);
		this.timelineInstant.fromTo(
			this.elements.rows[3],
			{
				xPercent: -40,
			},
			{
				xPercent: 10,
				ease: 'out.expo',
				duration: 1.25,
			},
			0
		);
		this.timelineInstant.fromTo(
			this.elements.rows[4],
			{
				xPercent: 40,
			},
			{
				xPercent: -10,
				ease: 'out.expo',
				duration: 1.25,
			},
			0
		);
		this.timelineInstant.fromTo(
			this.elements.container,
			{ scale: 1.5, rotate: 0 },
			{ scale: 1.75, rotate: -10, ease: 'out.expo', duration: 1.25 },
			0
		);
	}

	animateHeight() {}

	revealDescription(el) {
		console.log(el);
		let target;
		let targetSvg;

		if (el.classList.contains('faq__element')) {
			target = el.querySelector('.faq__element-description');
			targetSvg = el.querySelector('.faq__element-svg');
		} else {
			const parent = el.closest('.faq__element');
			target = parent.querySelector('.faq__element-description');
			targetSvg = parent.querySelector('.faq__element-svg');
		}

		target.dataset.revealed =
			target.dataset.revealed === 'true' ? 'false' : 'true';
		console.log(target.dataset.revealed);
		const vh = target.dataset.revealed === 'true' ? '100vh' : '0vh';
		const rotate = target.dataset.revealed === 'true' ? '360deg' : '180deg';

		GSAP.to(target, {
			maxHeight: vh,
			duration: 0.3,
			ease: 'power4.out',
		});

		GSAP.to(targetSvg, {
			rotate: rotate,
			duration: 0.7,
			ease: 'power4.out',
			onComplete: () => {
				if (target.dataset.revealed === 'true')
					GSAP.set(targetSvg, { rotate: 0 });
			},
		});
	}

	addEventListeners() {
		each(this.elements.items, (el) => {
			el.addEventListener('click', (e) => {
				this.revealDescription(e.target);
			});
		});
	}

	removeEventListeners() {
		each(this.elements.items, (el) => {
			el.removeEventListener('click', (e) => {
				this.revealDescription(e.target);
			});
		});
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();

		if (this.timelineInstant) {
			this.timelineInstant.kill();
			this.timelineInstant = null;
		}
	}
}
